import { SpinnerIndicators } from '@clearkit/icons';

import * as Well from './Well';

export function Loading() {
  return (
    <Well.Root>
      <Well.Icon>
        <SpinnerIndicators />
      </Well.Icon>
      <Well.Content>
        <Well.Heading>Loading your custom objects from Salesforce</Well.Heading>
      </Well.Content>
    </Well.Root>
  );
}
